import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import PsListForm from './PsListForm';
/**
 * PS画面メインエリア
 */
function PsListPageMainArea() {
  const { t } = useTranslation();
  return (
    <div id="main">
      <Helmet>
        <title>{t('CMS-POC|PS一覧')}</title>
      </Helmet>
      <PsListForm />
    </div>
  );
}

export default PsListPageMainArea;
